import { Component, Input, OnInit } from '@angular/core';
import { RodzajProjektu } from 'src/app/modele/projekty/rodzajProjektu';

@Component({
  selector: 'app-menu-projektu',
  templateUrl: './menu-projektu.component.html',
  styleUrls: ['./menu-projektu.component.css'],
})
export class MenuProjektuComponent implements OnInit {
  @Input() czyPracownikKlienta: boolean;
  @Input() czySpisSamodzielnyKlienta: boolean;
  @Input() idProjektu: string;
  @Input() rodzajProjektu: RodzajProjektu;
  @Input() czyMobile: boolean;
  @Input() czyAdmin: string;
  @Input() aktywnyAdres: string;

  slideConfig = {
    slidesToShow: 2,
    slidesToScroll: 1,
    prevArrow: document.getElementsByClassName('btn__left'),
    nextArrow: document.getElementsByClassName('btn__right'),
    infinite: false,
    variableWidth: true,
  };

  constructor() {}

  ngOnInit(): void {}
}
